document.addEventListener('turbolinks:load', initPropertyChargeLines);

function initPropertyChargeLines() {
  var container = document.getElementById('property-charge-lines');
  var addButton = document.getElementById('add-property-charge-line');
  if (!container || !addButton) return;

  var lineIndex = container.querySelectorAll('.nested-fields').length + 10;
  var cls = 'mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm';

  // Clone button to remove any stale listeners from turbolinks
  var freshButton = addButton.cloneNode(true);
  addButton.parentNode.replaceChild(freshButton, addButton);

  freshButton.addEventListener('click', function(e) {
    e.preventDefault();
    lineIndex++;
    var pre = 'property[property_charge_lines_attributes][' + lineIndex + ']';
    var newLine = document.createElement('div');
    newLine.className = 'nested-fields mb-4 p-4 bg-gray-50 rounded-lg';
    newLine.dataset.newRecord = 'true';
    newLine.innerHTML =
      '<div class="grid grid-cols-12 gap-4 items-end">' +
      '<div class="col-span-2">' +
        '<label class="block text-sm font-medium text-gray-700">Type</label>' +
        '<select name="' + pre + '[line_type]" class="' + cls + '">' +
          '<option value="">Sélectionner...</option>' +
          '<option value="energy">Énergie</option>' +
          '<option value="water">Eau</option>' +
          '<option value="repair">Réparations</option>' +
          '<option value="cleaning">Nettoyage</option>' +
          '<option value="other">Autre</option>' +
        '</select>' +
      '</div>' +
      '<div class="col-span-3">' +
        '<label class="block text-sm font-medium text-gray-700">Description</label>' +
        '<input type="text" name="' + pre + '[description]" class="' + cls + '" placeholder="Ex: Régularisation des charges">' +
      '</div>' +
      '<div class="col-span-2">' +
        '<label class="block text-sm font-medium text-gray-700">Début</label>' +
        '<input type="date" name="' + pre + '[start_date]" class="' + cls + '">' +
      '</div>' +
      '<div class="col-span-2">' +
        '<label class="block text-sm font-medium text-gray-700">Fin</label>' +
        '<input type="date" name="' + pre + '[end_date]" class="' + cls + '">' +
      '</div>' +
      '<div class="col-span-2">' +
        '<label class="block text-sm font-medium text-gray-700">Montant (€)</label>' +
        '<input type="number" step="0.01" min="0" name="' + pre + '[amount]" class="' + cls + '" placeholder="0.00">' +
      '</div>' +
      '<div class="col-span-1 flex items-end">' +
        '<input type="hidden" name="' + pre + '[_destroy]" class="destroy-field" value="0">' +
        '<button type="button" class="remove-charge-line inline-flex items-center px-3 py-2 border border-red-300 text-sm leading-4 font-medium rounded-md text-red-700 bg-white hover:bg-red-50" title="Supprimer">' +
          '<svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>' +
        '</button>' +
      '</div>' +
      '</div>';
    container.appendChild(newLine);
    setupChargeRemoveButtons();
  });

  setupChargeRemoveButtons();
}

function setupChargeRemoveButtons() {
  document.querySelectorAll('.remove-charge-line').forEach(function(btn) {
    btn.onclick = function(e) {
      e.preventDefault();
      var line = btn.closest('.nested-fields');
      if (line.dataset.newRecord === 'true') {
        line.remove();
      } else {
        var destroyField = line.querySelector('.destroy-field');
        if (destroyField) destroyField.value = '1';
        line.style.display = 'none';
      }
    };
  });
}
